import { fetchUserRating } from "./utils";
import { useCurrentUser } from "@/hooks/user/useCurrentUser";
import { Rating } from "@knowt/syncing/graphql/schema";
import { useSWRImmutable } from "@/hooks/swr/immutable";

export const useUserRating = ({ itemId, isEnabled = false }: { itemId: string; isEnabled?: boolean }) => {
    const { userId } = useCurrentUser();

    const { data, error, mutate, isValidating } = useSWRImmutable(
        itemId && userId && isEnabled && ["userRating", itemId, userId],
        async () => (await fetchUserRating({ noteId: itemId, userId })) as Rating
    );

    return { userRating: data, error, mutate, isValidating };
};
